import { handleActions } from 'redux-actions-helpers';
import { getTournamentsSuccess, tournamentsReorder, searchEvent, getTournamentsStart, resetTournaments, deleteEvent } from './actions';
import { reorder } from '../utils';

export const initialState = {
    items        : {},
    isSearchEvent: false,
    isLoaded     : false
};

export default handleActions({
    [getTournamentsStart]: (state) => {
        return {
            ...state,
            isLoaded: false
        }
    },
    [getTournamentsSuccess]: (state, { payload }) => {
        if(Array.isArray(payload) && !payload.length) {
            return initialState
        }

        return {
            ...state,
            items: {
                ...state.items,
                ...payload
            },
            isSearchEvent: false,
            isLoaded     : true
        }
    },
    [tournamentsReorder]: (state, { startIndex, endIndex, gameId }) => {
        if(state.isSearchEvent) {
            return {
                ...state,
                items: reorder(state.items, startIndex, endIndex)
            }
        }

        return {
            ...state,
            items: {
                ...state.items,
                [gameId]: reorder(state.items[gameId], startIndex, endIndex)
            }
        }
    },
    [searchEvent]: (state, { payload }) => {
        const items = Array.isArray(state.items) ? state.items : [];

        if(state.items.length && state.items.find((tournament) => tournament._id === payload._id)) {
            return state
        }

        return {
            ...state,
            isSearchEvent: true,
            isLoaded     : true,
            items        : items.concat(payload)
        }
    },
    [deleteEvent]: (state, { event }) => {
        const items = state.items.filter((eventItem) => eventItem._id !== event._id);

        return {
            ...state,
            items: items.length ? items : {}
        }
    },
    [resetTournaments]: () => {
        return initialState
    }
}, { initialState });



// WEBPACK FOOTER //
// ./src/blocks/tournaments/reducer.js